import { StyledLine } from "./styles.js";

export const Divider = () => {
    return <StyledLine />;
};
